import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ElevenLabsVoiceService {
    constructor(private http: HttpClient) {}

    async synthesize(text: string): Promise<Blob> {
        // The application's POST interceptor encrypts `body` before it leaves
        // the browser. Keep the voice request on the same protected path.
        return firstValueFrom(this.http.post('api/voice/speak', { body: { text } }, {
            headers: new HttpHeaders({ 'ngsw-bypass': '' }),
            responseType: 'blob',
        }));
    }

    async createScribeToken(): Promise<string> {
        const response = await firstValueFrom(this.http.post<{ token: string }>('api/voice/scribe-token', { body: {} }, {
            headers: new HttpHeaders({ 'ngsw-bypass': '' }),
        }));
        return String(response?.token || '');
    }

    async createAgentSignedUrl(): Promise<string> {
        const response = await firstValueFrom(this.http.post<{ signed_url: string }>('api/voice/agent-signed-url', { body: {} }, {
            headers: new HttpHeaders({ 'ngsw-bypass': '' }),
        }));
        return String(response?.signed_url || '');
    }

    async saveAgentTranscript(payload: { partnerid: string; username: string; text: string; source: 'user' | 'ai'; conversationId: string }): Promise<{ ok?: boolean; cardsHtml?: string }> {
        return firstValueFrom(this.http.post<{ ok?: boolean; cardsHtml?: string }>('api/voice/agent-transcript', { body: payload }, {
            headers: new HttpHeaders({ 'ngsw-bypass': '' }),
        }));
    }

    async renderAgentOfferCards(partnerid: string, toolName: string, toolResult: unknown): Promise<{ ok?: boolean; cardsHtml?: string }> {
        return firstValueFrom(this.http.post<{ ok?: boolean; cardsHtml?: string }>('api/voice/agent-offers', {
            body: { partnerid, toolName, toolResult },
        }, { headers: new HttpHeaders({ 'ngsw-bypass': '' }) }));
    }
}
